// extracted by mini-css-extract-plugin
module.exports = {"changesToBeDoneLastText":"VerifyStatusModal_changesToBeDoneLastText__3JpLm","flex":"VerifyStatusModal_flex__1jGYN","stepContainer":"VerifyStatusModal_stepContainer__2KvWG"};